export const CDN_HOST = [
  'static.weeecdn.com',
  'img06.weeecdn.com',
  'video.sayweeecdn.com',
  'cdn.sayweee.net',
  'cdn02.sayweee.net',
  'cdn01.sayweee.net',
  'images-static.sayweeecdn.com',
  'img01.sayweeecdn.com',
  'images01.sayweeecdn.com',
  'img.test.weeecdn.com',
  'static.weeecdn.com'
];

export const CDN_PREFETCH_HOST = ['static.weeecdn.net', 'img08.weeecdn.net', 'weee.pics', 'api.anycart.com'];
